
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIVmdu0jD0gyzcwoz2afdt550uHeGCfGp8wxHOBCbCRUMeta } from "/srv/www/uia-frontend/pages/index.vue?macro=true";
import { default as pressUI7FdOxkWNol6viAe7RndqxVGFeIp47q2MuI5Gnn79IMeta } from "/srv/www/uia-frontend/pages/press.vue?macro=true";
import { default as search78NhxuRorBfSYXnH0Np5eLz9oiHlXgTw1c2lHnC34gkMeta } from "/srv/www/uia-frontend/pages/search.vue?macro=true";
import { default as contactZFNQYSpMsH67IkqNBPu57D4NmF93he2G6FSzR4xDVw8Meta } from "/srv/www/uia-frontend/pages/contact.vue?macro=true";
import { default as email_wxWQ_XQmx0PUpqa5okvMB6V12DxcsnZovNYOkFbHPUMeta } from "/srv/www/uia-frontend/pages/auth/email.vue?macro=true";
import { default as choosehwQrkaFMYIMmyNDOQfAuwlbcW6IqHLuXlIBDnw_PreAMeta } from "/srv/www/uia-frontend/pages/auth/choose.vue?macro=true";
import { default as signupNkAlcMSjkXtIcpLDS1knSdbZPQNbQjoEh_45_g_p3giRYMeta } from "/srv/www/uia-frontend/pages/auth/signup.vue?macro=true";
import { default as confirmitkMvhF2Yg19vi_457GFI9v_45yb4VRuILxDoYcKL_45ZoeasMeta } from "/srv/www/uia-frontend/pages/auth/confirm.vue?macro=true";
import { default as indexdu_45_45WjtH6_45xK_458TKcbtRGGEs3yheLWPnQLwdcCAhsTMMeta } from "/srv/www/uia-frontend/pages/events/index.vue?macro=true";
import { default as _91slug_93ymtHZLKzHr_O6uCl4lzbp_C2nZaWYU0GffG9_SA9DFMMeta } from "/srv/www/uia-frontend/pages/pages/[slug].vue?macro=true";
import { default as indexlZLOqcdMCj4J0muIbQzVzjL_45d44REDW89rL1nqU_45zlIMeta } from "/srv/www/uia-frontend/pages/actions/index.vue?macro=true";
import { default as redirectX5s7DCI2RAdWY89mAT9SJXsrNxq3XdWjcDZkeuqmcGoMeta } from "/srv/www/uia-frontend/pages/auth/redirect.vue?macro=true";
import { default as firmsu_45p8xo7AP3veIY_E82i46jmbniweM9nidBKlJjZltrAMeta } from "/srv/www/uia-frontend/pages/members/firms.vue?macro=true";
import { default as indexWKPDMM_ixMNmJdwWnK_zlQqIYgI39kfZphuYtNh7QzcMeta } from "/srv/www/uia-frontend/pages/members/index.vue?macro=true";
import { default as _91slug_93lY_4533C4wolfC_cm_euImmsuTaKCojgyBY0owHDjrvQUMeta } from "/srv/www/uia-frontend/pages/actions/[slug].vue?macro=true";
import { default as indexGTBwhLumZ3aYouscy8uCQX5XU7b5KtnccxPAfFqlWCIMeta } from "/srv/www/uia-frontend/pages/articles/index.vue?macro=true";
import { default as subscribe5FclS4vkdpk77fSv7kbdIU2E_f4xOZgiBpMhYeuen90Meta } from "/srv/www/uia-frontend/pages/auth/subscribe.vue?macro=true";
import { default as indexwwMhijJLNyiaXyL3M8FPSwhFnMdJRcUT6cHa338AUpYMeta } from "/srv/www/uia-frontend/pages/mandates/index.vue?macro=true";
import { default as _91slug_930WS34_45JE9thsby_45F0ZMz7KZXCOuvHKlU9nbSIAVFKOEMeta } from "/srv/www/uia-frontend/pages/members/[slug].vue?macro=true";
import { default as podcasts9LMZcZA3maadCRAOi8KvYnmktvgmA5lTxNQdC2EiHd8Meta } from "/srv/www/uia-frontend/pages/pages/podcasts.vue?macro=true";
import { default as indexqxbhsOzGIelphO3ENh_k0j_45lroWMZ_8OjMMW2p5U0iMMeta } from "/srv/www/uia-frontend/pages/partners/index.vue?macro=true";
import { default as indexGWnULXB4agw0tvv4uxDDcmxoviuolKzeEDTMbQ941qkMeta } from "/srv/www/uia-frontend/pages/uia-irol/index.vue?macro=true";
import { default as _91slug_93xY7CNHsJEXLP7SEyVq1ys1_45bmz2kU_M1fNmtoZcZbq8Meta } from "/srv/www/uia-frontend/pages/articles/[slug].vue?macro=true";
import { default as uiacademyrJGwnXo717tgfHJMiAwNAvlohK4QSozFqxvVhHwCRUcMeta } from "/srv/www/uia-frontend/pages/pages/uiacademy.vue?macro=true";
import { default as uiadvanceWqfgYhJdOi3uC4uvWx8dJGwQFwSRDrbLMbvTkol_45Zh8Meta } from "/srv/www/uia-frontend/pages/pages/uiadvance.vue?macro=true";
import { default as index3zslCT6dnrqa7r3SOWjwuNss4br5HjjKClTp9_450M8cQMeta } from "/srv/www/uia-frontend/pages/committees/index.vue?macro=true";
import { default as governanceU1PIqRUOkGwPCL7h9RNhAVe3a3B2Il_45BeMvXbSMzj8QMeta } from "/srv/www/uia-frontend/pages/pages/governance.vue?macro=true";
import { default as learn_45moreq6ng8pe7elbmhefWSRjwlZGxkIXRoTouqh7Td_45lsuf0Meta } from "/srv/www/uia-frontend/pages/pages/learn-more.vue?macro=true";
import { default as who_45we_45arec_45WK916TkSr3zrPYJ8WU5Ns_45pcCYgBScIsPZ4sIWixkMeta } from "/srv/www/uia-frontend/pages/pages/who-we-are.vue?macro=true";
import { default as indexUv_45YugJ8pVpBtOeep0MgYqNbFX7x70og4oWM3px_4LwMeta } from "/srv/www/uia-frontend/pages/commissions/index.vue?macro=true";
import { default as _91slug_93yOUlA67iijfNL_452rKwME1uhRFthN7KQHEmEX1O3uxIIMeta } from "/srv/www/uia-frontend/pages/committees/[slug].vue?macro=true";
import { default as sponsorshipIO2J7HFNfwUoL4TS_pdT2MQ_oXNiMXPxBoCnN_45cUjJcMeta } from "/srv/www/uia-frontend/pages/pages/sponsorship.vue?macro=true";
import { default as access_45deniedGLGN5eVuc3TY1FRrOzyHQ04a8nsJexorVPW5q3qim7IMeta } from "/srv/www/uia-frontend/pages/auth/access-denied.vue?macro=true";
import { default as indexxPVlXrHzSOD9EBzvf5ZuE518y25aChwPWhEE8j4AXsAMeta } from "/srv/www/uia-frontend/pages/auth/private/index.vue?macro=true";
import { default as _91slug_93j3Wy7V8_450s6bO7rpEFoKgW8EEpTgPpg0UL8peWYnpnIMeta } from "/srv/www/uia-frontend/pages/commissions/[slug].vue?macro=true";
import { default as indexqw5ZIC1XYknKmk33FfOmybU0f499NjmRqbaOJ_N1OzsMeta } from "/srv/www/uia-frontend/pages/members/bars/index.vue?macro=true";
import { default as join_45the_45uiaMMsEO2YAM8GigHU_IVrZih3IgmhwFAAc1a9WOvy0AFIMeta } from "/srv/www/uia-frontend/pages/pages/join-the-uia.vue?macro=true";
import { default as index0tuhh5NjJRvhkCbt_45O0o9TL6TiSUJhi8FxvJYRwong4Meta } from "/srv/www/uia-frontend/pages/publications/index.vue?macro=true";
import { default as eventsOXcxl6sl_OwIYNSVFSE5ozn8OHHk_45fAtoZjGgHXa5zgMeta } from "/srv/www/uia-frontend/pages/auth/private/events.vue?macro=true";
import { default as reset_45passwordT9JRwByy335i5Y1KJ52yaV3aMi43_4gdzHgp55bu0wsMeta } from "/srv/www/uia-frontend/pages/auth/reset-password.vue?macro=true";
import { default as indexxlnyxIxVfQfhWbd8mLIdrDQOIzVOdivRde9v2LTC5bUMeta } from "/srv/www/uia-frontend/pages/events/[slug]/index.vue?macro=true";
import { default as _91slug_93rWgGMTshj74ta_452jo75PtdSMs93iZObvErnpYK0iR50Meta } from "/srv/www/uia-frontend/pages/members/bars/[slug].vue?macro=true";
import { default as paymentej05j6Scen_X1Es0Wu5aIH_45OxR_m9B4Gv6zK1d29Z74Meta } from "/srv/www/uia-frontend/pages/auth/private/payment.vue?macro=true";
import { default as profileszHRfuAax1x1GTlIq8n1hdRNNk_qyM30i_45e_zJcvn2IMeta } from "/srv/www/uia-frontend/pages/auth/private/profile.vue?macro=true";
import { default as endowment_45fundMTa4zOVbQCvxRaeeQ9uLFl7rFR9nVqcC5FsgEVh8w9QMeta } from "/srv/www/uia-frontend/pages/pages/endowment-fund.vue?macro=true";
import { default as index8TZmk_45j4uoz7YTMLPkWxSKbZ0hrYdfvx00p7T7Upbu0Meta } from "/srv/www/uia-frontend/pages/partner-events/index.vue?macro=true";
import { default as mandatesUK6jdVcnIaED7kz5KsDLsK33iTyheF3p03S0qINFmj4Meta } from "/srv/www/uia-frontend/pages/auth/private/mandates.vue?macro=true";
import { default as _91documentId_93d_45zL2Y_45TX8Lo_asS7qmmaSC_5ZXxf1T8q9w3fpS_v_458Meta } from "/srv/www/uia-frontend/pages/mandates/[documentId].vue?macro=true";
import { default as registerk89J1nTT2VNf_T6j5086TblTk35aO_gX31_9oIdP61UMeta } from "/srv/www/uia-frontend/pages/events/[slug]/register.vue?macro=true";
import { default as committeesXCBboMfSSMc24oSei9x1e5nW2fw6lDaivpmnWMoYEhoMeta } from "/srv/www/uia-frontend/pages/auth/private/committees.vue?macro=true";
import { default as indexEuqF4k3od2Q2pnLW283G3dj0pxgV13lmyF0_7nPRcg0Meta } from "/srv/www/uia-frontend/pages/documents-library/index.vue?macro=true";
import { default as become_45uia_45member5suFQSNm0ZzfDIB9Oi7C4T_ThIj59POwzqhDSg45_WcMeta } from "/srv/www/uia-frontend/pages/pages/become-uia-member.vue?macro=true";
import { default as bar_45membersnx6iY2W9XaHVhzkQI9v9uMinPIkJfWlGtoXoh7PQ8iIMeta } from "/srv/www/uia-frontend/pages/auth/private/bar-members.vue?macro=true";
import { default as bar_45profileFXWFrLsdkn8MXQInxbRYOWxqnDx_onhEdQ11XwjE9J4Meta } from "/srv/www/uia-frontend/pages/auth/private/bar-profile.vue?macro=true";
import { default as commissionsa_45ptiD2uuuOAmf_r_RplfOI9knQ5uunBAlxY4IKTUsoMeta } from "/srv/www/uia-frontend/pages/auth/private/commissions.vue?macro=true";
import { default as change_45email_45confirm7XDyvHoQEywO1VfqXXw0aw4fx7jL2wO4_WbRcTzQY7EMeta } from "/srv/www/uia-frontend/pages/auth/change-email-confirm.vue?macro=true";
import { default as change_45emailoEDvlQe6lbH2ZRzFwEdV_45sfl20Db2fZ_ZuAXw4njAuwMeta } from "/srv/www/uia-frontend/pages/auth/private/change-email.vue?macro=true";
import { default as firm_45membersoeMpUlAipLCHYJeUdMlRy2pVMU1tlG6Vv2pBI1oJRwEMeta } from "/srv/www/uia-frontend/pages/auth/private/firm-members.vue?macro=true";
import { default as firm_45profilexKVPc718_BojkvWZDTZWCPkvfe1QVmMfSl_45uWg1hnvIMeta } from "/srv/www/uia-frontend/pages/auth/private/firm-profile.vue?macro=true";
import { default as my_45documentsWDFQWswRezmoFBp2YuPNOiLPjBQn4TFISeYVJxF64VMMeta } from "/srv/www/uia-frontend/pages/auth/private/my-documents.vue?macro=true";
import { default as transactionszp_455u1PIMQjbzXXkSSh6hEMmERmMRcJX8jJh79vIi9YMeta } from "/srv/www/uia-frontend/pages/auth/private/transactions.vue?macro=true";
import { default as refer_45a_45friendRNVTwfat7TwP1_45dVSKezeUziUGlK3m_SSxbmv_45PT2BQMeta } from "/srv/www/uia-frontend/pages/membership/refer-a-friend.vue?macro=true";
import { default as indexETwgCZ_Mtx4EkRWJ_450W72Hj44YCxxtwpfuHQmXoXTEcMeta } from "/srv/www/uia-frontend/pages/national-committees/index.vue?macro=true";
import { default as _91documentId_93mGgETeJuZS_45ggT2vRTfakMGo64IaCvcspA8YI0FtAjkMeta } from "/srv/www/uia-frontend/pages/publications/[documentId].vue?macro=true";
import { default as _91slug_93q315p7T_LF_45HAbsQVjgrFa6uAN7LFoadmieJ4GDbtR0Meta } from "/srv/www/uia-frontend/pages/national-committees/[slug].vue?macro=true";
import { default as payment_45result_45fy9ac3HSd2fg3yaMoBS358WuA6TSnBm7C5Pnd44yuEMeta } from "/srv/www/uia-frontend/pages/auth/private/payment-result.vue?macro=true";
import { default as indexFNArWGNKaYCwq0dIzYiDV9pH37ln7wzVOi8yQyiL6hEMeta } from "/srv/www/uia-frontend/pages/user-commission-roles/index.vue?macro=true";
import { default as indexAuBQr_452q2hR_CBOGe5wFbdeCMSQt9ld_oMqQRhONKRYMeta } from "/srv/www/uia-frontend/pages/juriste-internationals/index.vue?macro=true";
import { default as bars_45and_45organisationskovKgzIYR_45mMuGv3s1GZqSkUpMnLNPZVOAA7ZiXQnLMMeta } from "/srv/www/uia-frontend/pages/pages/bars-and-organisations.vue?macro=true";
import { default as index65D6Hu1srtrqEzSK4aTrl3oKr1kFXiCB_45KT6CccD06YMeta } from "/srv/www/uia-frontend/pages/charters-and-resolutions/index.vue?macro=true";
import { default as _91documentId_93syMaJ20xYJRymzszP_FPUHSX0kxYiD0UiTtiqvLGlZQMeta } from "/srv/www/uia-frontend/pages/documents-library/[documentId].vue?macro=true";
import { default as register_45confirmyjpinmzZpsAYkWEwvzrM1Swcqg7oYQKcfcZDVu2inOsMeta } from "/srv/www/uia-frontend/pages/events/[slug]/register-confirm.vue?macro=true";
import { default as national_45committeesfv_45bYWeZWwHXU6ypuZXdz1fZ9uMeVv625D7jKI4p_cMMeta } from "/srv/www/uia-frontend/pages/auth/private/national-committees.vue?macro=true";
import { default as _91documentId_93hiBrQE0zTotb8SbK6ptV73V3GxbPfLsvRRii7ESpYksMeta } from "/srv/www/uia-frontend/pages/user-commission-roles/[documentId].vue?macro=true";
import { default as president_45communicationnGU5ab_45_epPitHyqPUFkfx4_gdI8wxqWkrNLdTLu_s8Meta } from "/srv/www/uia-frontend/pages/auth/private/president-communication.vue?macro=true";
import { default as uia_45world_45forum_45of_45mediation_45centresEYBgBwSKMY55VLt5CunQHNFjWYiecj6TyKcajLXyNxQMeta } from "/srv/www/uia-frontend/pages/pages/uia-world-forum-of-mediation-centres.vue?macro=true";
import { default as component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IAMeta } from "/srv/www/uia-frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IA } from "/srv/www/uia-frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["breadcrumbs"]},
    component: () => import("/srv/www/uia-frontend/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: {"middleware":["breadcrumbs"]},
    component: () => import("/srv/www/uia-frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: {"middleware":["breadcrumbs"]},
    component: () => import("/srv/www/uia-frontend/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: {"middleware":["breadcrumbs"]},
    component: () => import("/srv/www/uia-frontend/pages/index.vue")
  },
  {
    name: "press___fr",
    path: "/fr/a-propos/presse",
    component: () => import("/srv/www/uia-frontend/pages/press.vue")
  },
  {
    name: "press___en",
    path: "/en/about/press",
    component: () => import("/srv/www/uia-frontend/pages/press.vue")
  },
  {
    name: "press___es",
    path: "/es/sobre-la-uia/prensa",
    component: () => import("/srv/www/uia-frontend/pages/press.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    component: () => import("/srv/www/uia-frontend/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/srv/www/uia-frontend/pages/search.vue")
  },
  {
    name: "search___es",
    path: "/es/busqueda",
    component: () => import("/srv/www/uia-frontend/pages/search.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/srv/www/uia-frontend/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/srv/www/uia-frontend/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contacto",
    component: () => import("/srv/www/uia-frontend/pages/contact.vue")
  },
  {
    name: "auth-email___fr",
    path: "/fr/compte/email",
    component: () => import("/srv/www/uia-frontend/pages/auth/email.vue")
  },
  {
    name: "auth-email___en",
    path: "/en/account/email",
    component: () => import("/srv/www/uia-frontend/pages/auth/email.vue")
  },
  {
    name: "auth-email___es",
    path: "/es/auth/email",
    component: () => import("/srv/www/uia-frontend/pages/auth/email.vue")
  },
  {
    name: "auth-choose___fr",
    path: "/fr/compte/choisir",
    component: () => import("/srv/www/uia-frontend/pages/auth/choose.vue")
  },
  {
    name: "auth-choose___en",
    path: "/en/account/choose",
    component: () => import("/srv/www/uia-frontend/pages/auth/choose.vue")
  },
  {
    name: "auth-choose___es",
    path: "/es/cuenta/elegir",
    component: () => import("/srv/www/uia-frontend/pages/auth/choose.vue")
  },
  {
    name: "auth-signup___fr",
    path: "/fr/compte/inscription",
    component: () => import("/srv/www/uia-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___en",
    path: "/en/account/signup",
    component: () => import("/srv/www/uia-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___es",
    path: "/es/cuenta/registro",
    component: () => import("/srv/www/uia-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-confirm___fr",
    path: "/fr/compte/confirmer",
    component: () => import("/srv/www/uia-frontend/pages/auth/confirm.vue")
  },
  {
    name: "auth-confirm___en",
    path: "/en/account/confirm",
    component: () => import("/srv/www/uia-frontend/pages/auth/confirm.vue")
  },
  {
    name: "auth-confirm___es",
    path: "/es/cuenta/confirmar",
    component: () => import("/srv/www/uia-frontend/pages/auth/confirm.vue")
  },
  {
    name: "events___fr",
    path: "/fr/evenements",
    component: () => import("/srv/www/uia-frontend/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/en/events",
    component: () => import("/srv/www/uia-frontend/pages/events/index.vue")
  },
  {
    name: "events___es",
    path: "/es/eventos",
    component: () => import("/srv/www/uia-frontend/pages/events/index.vue")
  },
  {
    name: "pages-slug___fr",
    path: "/fr/pages/:slug()",
    meta: _91slug_93ymtHZLKzHr_O6uCl4lzbp_C2nZaWYU0GffG9_SA9DFMMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/pages/[slug].vue")
  },
  {
    name: "pages-slug___en",
    path: "/en/pages/:slug()",
    meta: _91slug_93ymtHZLKzHr_O6uCl4lzbp_C2nZaWYU0GffG9_SA9DFMMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/pages/[slug].vue")
  },
  {
    name: "pages-slug___es",
    path: "/es/paginas/:slug()",
    meta: _91slug_93ymtHZLKzHr_O6uCl4lzbp_C2nZaWYU0GffG9_SA9DFMMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/pages/[slug].vue")
  },
  {
    name: "actions___fr",
    path: "/fr/uia-irol/actions",
    meta: indexlZLOqcdMCj4J0muIbQzVzjL_45d44REDW89rL1nqU_45zlIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/index.vue")
  },
  {
    name: "actions___en",
    path: "/en/uia-irol/actions",
    meta: indexlZLOqcdMCj4J0muIbQzVzjL_45d44REDW89rL1nqU_45zlIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/index.vue")
  },
  {
    name: "actions___es",
    path: "/es/uia-irol/acciones",
    meta: indexlZLOqcdMCj4J0muIbQzVzjL_45d44REDW89rL1nqU_45zlIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/index.vue")
  },
  {
    name: "auth-redirect___fr",
    path: "/fr/compte/redirection",
    component: () => import("/srv/www/uia-frontend/pages/auth/redirect.vue")
  },
  {
    name: "auth-redirect___en",
    path: "/en/account/redirect",
    component: () => import("/srv/www/uia-frontend/pages/auth/redirect.vue")
  },
  {
    name: "auth-redirect___es",
    path: "/es/cuenta/redireccion",
    component: () => import("/srv/www/uia-frontend/pages/auth/redirect.vue")
  },
  {
    name: "members-firms___fr",
    path: "/fr/annuaire/cabinets",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/firms.vue")
  },
  {
    name: "members-firms___en",
    path: "/en/directory/firms",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/firms.vue")
  },
  {
    name: "members-firms___es",
    path: "/es/directorio/firmas",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/firms.vue")
  },
  {
    name: "members___fr",
    path: "/fr/annuaire/membres",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/index.vue")
  },
  {
    name: "members___en",
    path: "/en/directory/members",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/index.vue")
  },
  {
    name: "members___es",
    path: "/es/directorio/membresia",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/index.vue")
  },
  {
    name: "actions-slug___fr",
    path: "/fr/uia-irol/actions/:slug()",
    meta: _91slug_93lY_4533C4wolfC_cm_euImmsuTaKCojgyBY0owHDjrvQUMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/[slug].vue")
  },
  {
    name: "actions-slug___en",
    path: "/en/uia-irol/actions/:slug()",
    meta: _91slug_93lY_4533C4wolfC_cm_euImmsuTaKCojgyBY0owHDjrvQUMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/[slug].vue")
  },
  {
    name: "actions-slug___es",
    path: "/es/uia-irol/acciones/:slug()",
    meta: _91slug_93lY_4533C4wolfC_cm_euImmsuTaKCojgyBY0owHDjrvQUMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/actions/[slug].vue")
  },
  {
    name: "articles___fr",
    path: "/fr/actualites",
    component: () => import("/srv/www/uia-frontend/pages/articles/index.vue")
  },
  {
    name: "articles___en",
    path: "/en/news",
    component: () => import("/srv/www/uia-frontend/pages/articles/index.vue")
  },
  {
    name: "articles___es",
    path: "/es/noticias",
    component: () => import("/srv/www/uia-frontend/pages/articles/index.vue")
  },
  {
    name: "auth-subscribe___fr",
    path: "/fr/compte/adhesion",
    component: () => import("/srv/www/uia-frontend/pages/auth/subscribe.vue")
  },
  {
    name: "auth-subscribe___en",
    path: "/en/account/membership",
    component: () => import("/srv/www/uia-frontend/pages/auth/subscribe.vue")
  },
  {
    name: "auth-subscribe___es",
    path: "/es/cuenta/membresia",
    component: () => import("/srv/www/uia-frontend/pages/auth/subscribe.vue")
  },
  {
    name: "mandates___fr",
    path: "/fr/mandates",
    component: () => import("/srv/www/uia-frontend/pages/mandates/index.vue")
  },
  {
    name: "mandates___en",
    path: "/en/mandates",
    component: () => import("/srv/www/uia-frontend/pages/mandates/index.vue")
  },
  {
    name: "mandates___es",
    path: "/es/mandates",
    component: () => import("/srv/www/uia-frontend/pages/mandates/index.vue")
  },
  {
    name: "members-slug___fr",
    path: "/fr/annuaire/membres/:slug()",
    meta: _91slug_930WS34_45JE9thsby_45F0ZMz7KZXCOuvHKlU9nbSIAVFKOEMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/[slug].vue")
  },
  {
    name: "members-slug___en",
    path: "/en/directory/members/:slug()",
    meta: _91slug_930WS34_45JE9thsby_45F0ZMz7KZXCOuvHKlU9nbSIAVFKOEMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/[slug].vue")
  },
  {
    name: "members-slug___es",
    path: "/es/directorio/membresia/:slug()",
    meta: _91slug_930WS34_45JE9thsby_45F0ZMz7KZXCOuvHKlU9nbSIAVFKOEMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/[slug].vue")
  },
  {
    name: "pages-podcasts___fr",
    path: "/fr/ressources-digitales/podcasts-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/podcasts.vue")
  },
  {
    name: "pages-podcasts___en",
    path: "/en/digital-resources/uia-podcasts",
    component: () => import("/srv/www/uia-frontend/pages/pages/podcasts.vue")
  },
  {
    name: "pages-podcasts___es",
    path: "/es/recursos-digitales/podcasts-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/podcasts.vue")
  },
  {
    name: "partners___fr",
    path: "/fr/partenaires",
    component: () => import("/srv/www/uia-frontend/pages/partners/index.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/srv/www/uia-frontend/pages/partners/index.vue")
  },
  {
    name: "partners___es",
    path: "/es/asociados",
    component: () => import("/srv/www/uia-frontend/pages/partners/index.vue")
  },
  {
    name: "uia-irol___fr",
    path: "/fr/uia-irol",
    meta: indexGWnULXB4agw0tvv4uxDDcmxoviuolKzeEDTMbQ941qkMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/uia-irol/index.vue")
  },
  {
    name: "uia-irol___en",
    path: "/en/uia-irol",
    meta: indexGWnULXB4agw0tvv4uxDDcmxoviuolKzeEDTMbQ941qkMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/uia-irol/index.vue")
  },
  {
    name: "uia-irol___es",
    path: "/es/uia-irol",
    meta: indexGWnULXB4agw0tvv4uxDDcmxoviuolKzeEDTMbQ941qkMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/uia-irol/index.vue")
  },
  {
    name: "articles-slug___fr",
    path: "/fr/actualites/:slug()",
    meta: _91slug_93xY7CNHsJEXLP7SEyVq1ys1_45bmz2kU_M1fNmtoZcZbq8Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___en",
    path: "/en/news/:slug()",
    meta: _91slug_93xY7CNHsJEXLP7SEyVq1ys1_45bmz2kU_M1fNmtoZcZbq8Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___es",
    path: "/es/noticias/:slug()",
    meta: _91slug_93xY7CNHsJEXLP7SEyVq1ys1_45bmz2kU_M1fNmtoZcZbq8Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/articles/[slug].vue")
  },
  {
    name: "pages-uiacademy___fr",
    path: "/fr/uiacademy",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiacademy.vue")
  },
  {
    name: "pages-uiacademy___en",
    path: "/en/uiacademy",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiacademy.vue")
  },
  {
    name: "pages-uiacademy___es",
    path: "/es/uiacademy",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiacademy.vue")
  },
  {
    name: "pages-uiadvance___fr",
    path: "/fr/uiadvance",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiadvance.vue")
  },
  {
    name: "pages-uiadvance___en",
    path: "/en/uiadvance",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiadvance.vue")
  },
  {
    name: "pages-uiadvance___es",
    path: "/es/uiadvance",
    component: () => import("/srv/www/uia-frontend/pages/pages/uiadvance.vue")
  },
  {
    name: "committees___fr",
    path: "/fr/reseau/comites",
    component: () => import("/srv/www/uia-frontend/pages/committees/index.vue")
  },
  {
    name: "committees___en",
    path: "/en/network/committees",
    component: () => import("/srv/www/uia-frontend/pages/committees/index.vue")
  },
  {
    name: "committees___es",
    path: "/es/red/comites",
    component: () => import("/srv/www/uia-frontend/pages/committees/index.vue")
  },
  {
    name: "pages-governance___fr",
    path: "/fr/a-propos/gouvernance",
    component: () => import("/srv/www/uia-frontend/pages/pages/governance.vue")
  },
  {
    name: "pages-governance___en",
    path: "/en/about/governance",
    component: () => import("/srv/www/uia-frontend/pages/pages/governance.vue")
  },
  {
    name: "pages-governance___es",
    path: "/es/sobre-la-uia/gobernanza",
    component: () => import("/srv/www/uia-frontend/pages/pages/governance.vue")
  },
  {
    name: "pages-learn-more___fr",
    path: "/fr/en-savoir-plus",
    component: () => import("/srv/www/uia-frontend/pages/pages/learn-more.vue")
  },
  {
    name: "pages-learn-more___en",
    path: "/en/learn-more",
    component: () => import("/srv/www/uia-frontend/pages/pages/learn-more.vue")
  },
  {
    name: "pages-learn-more___es",
    path: "/es/saber-mas",
    component: () => import("/srv/www/uia-frontend/pages/pages/learn-more.vue")
  },
  {
    name: "pages-who-we-are___fr",
    path: "/fr/a-propos/qui-sommes-nous",
    component: () => import("/srv/www/uia-frontend/pages/pages/who-we-are.vue")
  },
  {
    name: "pages-who-we-are___en",
    path: "/en/about/who-we-are",
    component: () => import("/srv/www/uia-frontend/pages/pages/who-we-are.vue")
  },
  {
    name: "pages-who-we-are___es",
    path: "/es/sobre-la-uia/quienes-somos",
    component: () => import("/srv/www/uia-frontend/pages/pages/who-we-are.vue")
  },
  {
    name: "commissions___fr",
    path: "/fr/reseau/commissions",
    component: () => import("/srv/www/uia-frontend/pages/commissions/index.vue")
  },
  {
    name: "commissions___en",
    path: "/en/network/commissions",
    component: () => import("/srv/www/uia-frontend/pages/commissions/index.vue")
  },
  {
    name: "commissions___es",
    path: "/es/red/comisiones",
    component: () => import("/srv/www/uia-frontend/pages/commissions/index.vue")
  },
  {
    name: "committees-slug___fr",
    path: "/fr/reseau/comites/:slug()",
    meta: _91slug_93yOUlA67iijfNL_452rKwME1uhRFthN7KQHEmEX1O3uxIIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/committees/[slug].vue")
  },
  {
    name: "committees-slug___en",
    path: "/en/network/committees/:slug()",
    meta: _91slug_93yOUlA67iijfNL_452rKwME1uhRFthN7KQHEmEX1O3uxIIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/committees/[slug].vue")
  },
  {
    name: "committees-slug___es",
    path: "/es/red/comites/:slug()",
    meta: _91slug_93yOUlA67iijfNL_452rKwME1uhRFthN7KQHEmEX1O3uxIIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/committees/[slug].vue")
  },
  {
    name: "pages-sponsorship___fr",
    path: "/fr/partenariat",
    component: () => import("/srv/www/uia-frontend/pages/pages/sponsorship.vue")
  },
  {
    name: "pages-sponsorship___en",
    path: "/en/sponsorship",
    component: () => import("/srv/www/uia-frontend/pages/pages/sponsorship.vue")
  },
  {
    name: "pages-sponsorship___es",
    path: "/es/patrocinios",
    component: () => import("/srv/www/uia-frontend/pages/pages/sponsorship.vue")
  },
  {
    name: "auth-access-denied___fr",
    path: "/fr/compte/acces-refuse",
    component: () => import("/srv/www/uia-frontend/pages/auth/access-denied.vue")
  },
  {
    name: "auth-access-denied___en",
    path: "/en/account/access-denied",
    component: () => import("/srv/www/uia-frontend/pages/auth/access-denied.vue")
  },
  {
    name: "auth-access-denied___es",
    path: "/es/cuenta/acceso-denegado",
    component: () => import("/srv/www/uia-frontend/pages/auth/access-denied.vue")
  },
  {
    name: "auth-private___fr",
    path: "/fr/mon-espace",
    meta: { ...(indexxPVlXrHzSOD9EBzvf5ZuE518y25aChwPWhEE8j4AXsAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/index.vue")
  },
  {
    name: "auth-private___en",
    path: "/en/my-account",
    meta: { ...(indexxPVlXrHzSOD9EBzvf5ZuE518y25aChwPWhEE8j4AXsAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/index.vue")
  },
  {
    name: "auth-private___es",
    path: "/es/mi-cuenta",
    meta: { ...(indexxPVlXrHzSOD9EBzvf5ZuE518y25aChwPWhEE8j4AXsAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/index.vue")
  },
  {
    name: "commissions-slug___fr",
    path: "/fr/reseau/commissions/:slug()",
    meta: _91slug_93j3Wy7V8_450s6bO7rpEFoKgW8EEpTgPpg0UL8peWYnpnIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/commissions/[slug].vue")
  },
  {
    name: "commissions-slug___en",
    path: "/en/network/commissions/:slug()",
    meta: _91slug_93j3Wy7V8_450s6bO7rpEFoKgW8EEpTgPpg0UL8peWYnpnIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/commissions/[slug].vue")
  },
  {
    name: "commissions-slug___es",
    path: "/es/red/comisiones/:slug()",
    meta: _91slug_93j3Wy7V8_450s6bO7rpEFoKgW8EEpTgPpg0UL8peWYnpnIMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/commissions/[slug].vue")
  },
  {
    name: "members-bars___fr",
    path: "/fr/annuaire/barreaux",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/index.vue")
  },
  {
    name: "members-bars___en",
    path: "/en/directory/bars",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/index.vue")
  },
  {
    name: "members-bars___es",
    path: "/es/directorio/colegios",
    meta: {"middleware":["auth","access","contribution"]},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/index.vue")
  },
  {
    name: "pages-join-the-uia___fr",
    path: "/fr/adhesion-membres/rejoindre-luia",
    component: () => import("/srv/www/uia-frontend/pages/pages/join-the-uia.vue")
  },
  {
    name: "pages-join-the-uia___en",
    path: "/en/membership/join-the-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/join-the-uia.vue")
  },
  {
    name: "pages-join-the-uia___es",
    path: "/es/membresia/unirse-a-la-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/join-the-uia.vue")
  },
  {
    name: "publications___fr",
    path: "/fr/ressources-digitales/publications",
    component: () => import("/srv/www/uia-frontend/pages/publications/index.vue")
  },
  {
    name: "publications___en",
    path: "/en/digital-resources/publications",
    component: () => import("/srv/www/uia-frontend/pages/publications/index.vue")
  },
  {
    name: "publications___es",
    path: "/es/recursos-digitales/publicaciones",
    component: () => import("/srv/www/uia-frontend/pages/publications/index.vue")
  },
  {
    name: "auth-private-events___fr",
    path: "/fr/mon-espace/evenements",
    meta: { ...(eventsOXcxl6sl_OwIYNSVFSE5ozn8OHHk_45fAtoZjGgHXa5zgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/events.vue")
  },
  {
    name: "auth-private-events___en",
    path: "/en/my-account/events",
    meta: { ...(eventsOXcxl6sl_OwIYNSVFSE5ozn8OHHk_45fAtoZjGgHXa5zgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/events.vue")
  },
  {
    name: "auth-private-events___es",
    path: "/es/mi-cuenta/eventos",
    meta: { ...(eventsOXcxl6sl_OwIYNSVFSE5ozn8OHHk_45fAtoZjGgHXa5zgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/events.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/fr/compte/reinitialiser-mot-de-passe",
    component: () => import("/srv/www/uia-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/account/reset-password",
    component: () => import("/srv/www/uia-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/es/cuenta/restablecer-contrasena",
    component: () => import("/srv/www/uia-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "events-slug___fr",
    path: "/fr/evenements/:slug()",
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/index.vue")
  },
  {
    name: "events-slug___en",
    path: "/en/events/:slug()",
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/index.vue")
  },
  {
    name: "events-slug___es",
    path: "/es/eventos/:slug()",
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/index.vue")
  },
  {
    name: "members-bars-slug___fr",
    path: "/fr/annuaire/barreaux/:slug()",
    meta: _91slug_93rWgGMTshj74ta_452jo75PtdSMs93iZObvErnpYK0iR50Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/[slug].vue")
  },
  {
    name: "members-bars-slug___en",
    path: "/en/directory/bars/:slug()",
    meta: _91slug_93rWgGMTshj74ta_452jo75PtdSMs93iZObvErnpYK0iR50Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/[slug].vue")
  },
  {
    name: "members-bars-slug___es",
    path: "/es/directorio/colegios/:slug()",
    meta: _91slug_93rWgGMTshj74ta_452jo75PtdSMs93iZObvErnpYK0iR50Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/members/bars/[slug].vue")
  },
  {
    name: "auth-private-payment___fr",
    path: "/fr/mon-espace/paiement",
    meta: { ...(paymentej05j6Scen_X1Es0Wu5aIH_45OxR_m9B4Gv6zK1d29Z74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment.vue")
  },
  {
    name: "auth-private-payment___en",
    path: "/en/my-account/payment",
    meta: { ...(paymentej05j6Scen_X1Es0Wu5aIH_45OxR_m9B4Gv6zK1d29Z74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment.vue")
  },
  {
    name: "auth-private-payment___es",
    path: "/es/mi-cuenta/pago",
    meta: { ...(paymentej05j6Scen_X1Es0Wu5aIH_45OxR_m9B4Gv6zK1d29Z74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment.vue")
  },
  {
    name: "auth-private-profile___fr",
    path: "/fr/mon-espace/profil",
    meta: { ...(profileszHRfuAax1x1GTlIq8n1hdRNNk_qyM30i_45e_zJcvn2IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/profile.vue")
  },
  {
    name: "auth-private-profile___en",
    path: "/en/my-account/profile",
    meta: { ...(profileszHRfuAax1x1GTlIq8n1hdRNNk_qyM30i_45e_zJcvn2IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/profile.vue")
  },
  {
    name: "auth-private-profile___es",
    path: "/es/mi-cuenta/perfil",
    meta: { ...(profileszHRfuAax1x1GTlIq8n1hdRNNk_qyM30i_45e_zJcvn2IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/profile.vue")
  },
  {
    name: "pages-endowment-fund___fr",
    path: "/fr/a-propos/fonds-de-dotation-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/endowment-fund.vue")
  },
  {
    name: "pages-endowment-fund___en",
    path: "/en/about/uia-endowment-fund",
    component: () => import("/srv/www/uia-frontend/pages/pages/endowment-fund.vue")
  },
  {
    name: "pages-endowment-fund___es",
    path: "/es/sobre-la-uia/fondo-de-dotacion-de-la-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/endowment-fund.vue")
  },
  {
    name: "partner-events___fr",
    path: "/fr/evenements-partenaires",
    component: () => import("/srv/www/uia-frontend/pages/partner-events/index.vue")
  },
  {
    name: "partner-events___en",
    path: "/en/partner-events",
    component: () => import("/srv/www/uia-frontend/pages/partner-events/index.vue")
  },
  {
    name: "partner-events___es",
    path: "/es/eventos-asociados",
    component: () => import("/srv/www/uia-frontend/pages/partner-events/index.vue")
  },
  {
    name: "auth-private-mandates___fr",
    path: "/fr/mon-espace/mandats",
    meta: { ...(mandatesUK6jdVcnIaED7kz5KsDLsK33iTyheF3p03S0qINFmj4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/mandates.vue")
  },
  {
    name: "auth-private-mandates___en",
    path: "/en/my-account/mandates",
    meta: { ...(mandatesUK6jdVcnIaED7kz5KsDLsK33iTyheF3p03S0qINFmj4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/mandates.vue")
  },
  {
    name: "auth-private-mandates___es",
    path: "/es/mi-cuenta/mandatos",
    meta: { ...(mandatesUK6jdVcnIaED7kz5KsDLsK33iTyheF3p03S0qINFmj4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/mandates.vue")
  },
  {
    name: "mandates-documentId___fr",
    path: "/fr/mandates/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/mandates/[documentId].vue")
  },
  {
    name: "mandates-documentId___en",
    path: "/en/mandates/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/mandates/[documentId].vue")
  },
  {
    name: "mandates-documentId___es",
    path: "/es/mandates/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/mandates/[documentId].vue")
  },
  {
    name: "events-slug-register___fr",
    path: "/fr/evenements/:slug()/inscription",
    meta: registerk89J1nTT2VNf_T6j5086TblTk35aO_gX31_9oIdP61UMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register.vue")
  },
  {
    name: "events-slug-register___en",
    path: "/en/events/:slug()/register",
    meta: registerk89J1nTT2VNf_T6j5086TblTk35aO_gX31_9oIdP61UMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register.vue")
  },
  {
    name: "events-slug-register___es",
    path: "/es/eventos/:slug()/registro",
    meta: registerk89J1nTT2VNf_T6j5086TblTk35aO_gX31_9oIdP61UMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register.vue")
  },
  {
    name: "auth-private-committees___fr",
    path: "/fr/mon-espace/comites",
    meta: { ...(committeesXCBboMfSSMc24oSei9x1e5nW2fw6lDaivpmnWMoYEhoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/committees.vue")
  },
  {
    name: "auth-private-committees___en",
    path: "/en/my-account/committees",
    meta: { ...(committeesXCBboMfSSMc24oSei9x1e5nW2fw6lDaivpmnWMoYEhoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/committees.vue")
  },
  {
    name: "auth-private-committees___es",
    path: "/es/mi-cuenta/comites",
    meta: { ...(committeesXCBboMfSSMc24oSei9x1e5nW2fw6lDaivpmnWMoYEhoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/committees.vue")
  },
  {
    name: "documents-library___fr",
    path: "/fr/ressources-digitales/bibliotheque",
    meta: {"middleware":"auth"},
    component: () => import("/srv/www/uia-frontend/pages/documents-library/index.vue")
  },
  {
    name: "documents-library___en",
    path: "/en/digital-resources/library",
    meta: {"middleware":"auth"},
    component: () => import("/srv/www/uia-frontend/pages/documents-library/index.vue")
  },
  {
    name: "documents-library___es",
    path: "/es/recursos-digitales/biblioteca",
    meta: {"middleware":"auth"},
    component: () => import("/srv/www/uia-frontend/pages/documents-library/index.vue")
  },
  {
    name: "pages-become-uia-member___fr",
    path: "/fr/adhesion-membres/devenir-membre-de-luia",
    component: () => import("/srv/www/uia-frontend/pages/pages/become-uia-member.vue")
  },
  {
    name: "pages-become-uia-member___en",
    path: "/en/membership/become-uia-member",
    component: () => import("/srv/www/uia-frontend/pages/pages/become-uia-member.vue")
  },
  {
    name: "pages-become-uia-member___es",
    path: "/es/membresia/membresia-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/become-uia-member.vue")
  },
  {
    name: "auth-private-bar-members___fr",
    path: "/fr/mon-espace/representants-barreau",
    meta: { ...(bar_45membersnx6iY2W9XaHVhzkQI9v9uMinPIkJfWlGtoXoh7PQ8iIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-members.vue")
  },
  {
    name: "auth-private-bar-members___en",
    path: "/en/my-account/bar-members",
    meta: { ...(bar_45membersnx6iY2W9XaHVhzkQI9v9uMinPIkJfWlGtoXoh7PQ8iIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-members.vue")
  },
  {
    name: "auth-private-bar-members___es",
    path: "/es/mi-cuenta/miembros-colegio",
    meta: { ...(bar_45membersnx6iY2W9XaHVhzkQI9v9uMinPIkJfWlGtoXoh7PQ8iIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-members.vue")
  },
  {
    name: "auth-private-bar-profile___fr",
    path: "/fr/mon-espace/profil-barreau",
    meta: { ...(bar_45profileFXWFrLsdkn8MXQInxbRYOWxqnDx_onhEdQ11XwjE9J4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-profile.vue")
  },
  {
    name: "auth-private-bar-profile___en",
    path: "/en/my-account/bar-profile",
    meta: { ...(bar_45profileFXWFrLsdkn8MXQInxbRYOWxqnDx_onhEdQ11XwjE9J4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-profile.vue")
  },
  {
    name: "auth-private-bar-profile___es",
    path: "/es/mi-cuenta/perfil-colegio",
    meta: { ...(bar_45profileFXWFrLsdkn8MXQInxbRYOWxqnDx_onhEdQ11XwjE9J4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/bar-profile.vue")
  },
  {
    name: "auth-private-commissions___fr",
    path: "/fr/mon-espace/commissions",
    meta: { ...(commissionsa_45ptiD2uuuOAmf_r_RplfOI9knQ5uunBAlxY4IKTUsoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/commissions.vue")
  },
  {
    name: "auth-private-commissions___en",
    path: "/en/my-account/commissions",
    meta: { ...(commissionsa_45ptiD2uuuOAmf_r_RplfOI9knQ5uunBAlxY4IKTUsoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/commissions.vue")
  },
  {
    name: "auth-private-commissions___es",
    path: "/es/mi-cuenta/comisiones",
    meta: { ...(commissionsa_45ptiD2uuuOAmf_r_RplfOI9knQ5uunBAlxY4IKTUsoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/commissions.vue")
  },
  {
    name: "auth-change-email-confirm___fr",
    path: "/fr/compte/modifier-email",
    component: () => import("/srv/www/uia-frontend/pages/auth/change-email-confirm.vue")
  },
  {
    name: "auth-change-email-confirm___en",
    path: "/en/account/change-email",
    component: () => import("/srv/www/uia-frontend/pages/auth/change-email-confirm.vue")
  },
  {
    name: "auth-change-email-confirm___es",
    path: "/es/cuenta/cambiar-email",
    component: () => import("/srv/www/uia-frontend/pages/auth/change-email-confirm.vue")
  },
  {
    name: "auth-private-change-email___fr",
    path: "/fr/auth/private/change-email",
    meta: { ...(change_45emailoEDvlQe6lbH2ZRzFwEdV_45sfl20Db2fZ_ZuAXw4njAuwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/change-email.vue")
  },
  {
    name: "auth-private-change-email___en",
    path: "/en/auth/private/change-email",
    meta: { ...(change_45emailoEDvlQe6lbH2ZRzFwEdV_45sfl20Db2fZ_ZuAXw4njAuwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/change-email.vue")
  },
  {
    name: "auth-private-change-email___es",
    path: "/es/auth/private/change-email",
    meta: { ...(change_45emailoEDvlQe6lbH2ZRzFwEdV_45sfl20Db2fZ_ZuAXw4njAuwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/change-email.vue")
  },
  {
    name: "auth-private-firm-members___fr",
    path: "/fr/mon-espace/membres-cabinet",
    meta: { ...(firm_45membersoeMpUlAipLCHYJeUdMlRy2pVMU1tlG6Vv2pBI1oJRwEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-members.vue")
  },
  {
    name: "auth-private-firm-members___en",
    path: "/en/my-account/firm-members",
    meta: { ...(firm_45membersoeMpUlAipLCHYJeUdMlRy2pVMU1tlG6Vv2pBI1oJRwEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-members.vue")
  },
  {
    name: "auth-private-firm-members___es",
    path: "/es/mi-cuenta/miembros-firma",
    meta: { ...(firm_45membersoeMpUlAipLCHYJeUdMlRy2pVMU1tlG6Vv2pBI1oJRwEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-members.vue")
  },
  {
    name: "auth-private-firm-profile___fr",
    path: "/fr/mon-espace/profil-cabinet",
    meta: { ...(firm_45profilexKVPc718_BojkvWZDTZWCPkvfe1QVmMfSl_45uWg1hnvIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-profile.vue")
  },
  {
    name: "auth-private-firm-profile___en",
    path: "/en/my-account/firm-profile",
    meta: { ...(firm_45profilexKVPc718_BojkvWZDTZWCPkvfe1QVmMfSl_45uWg1hnvIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-profile.vue")
  },
  {
    name: "auth-private-firm-profile___es",
    path: "/es/mi-cuenta/perfil-firma",
    meta: { ...(firm_45profilexKVPc718_BojkvWZDTZWCPkvfe1QVmMfSl_45uWg1hnvIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/firm-profile.vue")
  },
  {
    name: "auth-private-my-documents___fr",
    path: "/fr/mon-espace/mes-documents",
    meta: { ...(my_45documentsWDFQWswRezmoFBp2YuPNOiLPjBQn4TFISeYVJxF64VMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/my-documents.vue")
  },
  {
    name: "auth-private-my-documents___en",
    path: "/en/my-account/my-documents",
    meta: { ...(my_45documentsWDFQWswRezmoFBp2YuPNOiLPjBQn4TFISeYVJxF64VMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/my-documents.vue")
  },
  {
    name: "auth-private-my-documents___es",
    path: "/es/mi-cuenta/mis-documentos",
    meta: { ...(my_45documentsWDFQWswRezmoFBp2YuPNOiLPjBQn4TFISeYVJxF64VMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/my-documents.vue")
  },
  {
    name: "auth-private-transactions___fr",
    path: "/fr/mon-espace/transactions",
    meta: { ...(transactionszp_455u1PIMQjbzXXkSSh6hEMmERmMRcJX8jJh79vIi9YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/transactions.vue")
  },
  {
    name: "auth-private-transactions___en",
    path: "/en/my-account/transactions",
    meta: { ...(transactionszp_455u1PIMQjbzXXkSSh6hEMmERmMRcJX8jJh79vIi9YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/transactions.vue")
  },
  {
    name: "auth-private-transactions___es",
    path: "/es/mi-cuenta/transacciones",
    meta: { ...(transactionszp_455u1PIMQjbzXXkSSh6hEMmERmMRcJX8jJh79vIi9YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/transactions.vue")
  },
  {
    name: "membership-refer-a-friend___fr",
    path: "/fr/adhesion-membres/parrainez-un-confrere",
    component: () => import("/srv/www/uia-frontend/pages/membership/refer-a-friend.vue")
  },
  {
    name: "membership-refer-a-friend___en",
    path: "/en/membership/refer-a-friend",
    component: () => import("/srv/www/uia-frontend/pages/membership/refer-a-friend.vue")
  },
  {
    name: "membership-refer-a-friend___es",
    path: "/es/membresia/recomiende-un-companero-o-companera",
    component: () => import("/srv/www/uia-frontend/pages/membership/refer-a-friend.vue")
  },
  {
    name: "national-committees___fr",
    path: "/fr/reseau/luia-dans-le-monde",
    component: () => import("/srv/www/uia-frontend/pages/national-committees/index.vue")
  },
  {
    name: "national-committees___en",
    path: "/en/network/the-uia-worldwide",
    component: () => import("/srv/www/uia-frontend/pages/national-committees/index.vue")
  },
  {
    name: "national-committees___es",
    path: "/es/red/la-uia-en-el-mundo",
    component: () => import("/srv/www/uia-frontend/pages/national-committees/index.vue")
  },
  {
    name: "publications-documentId___fr",
    path: "/fr/publications/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/publications/[documentId].vue")
  },
  {
    name: "publications-documentId___en",
    path: "/en/publications/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/publications/[documentId].vue")
  },
  {
    name: "publications-documentId___es",
    path: "/es/publications/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/publications/[documentId].vue")
  },
  {
    name: "national-committees-slug___fr",
    path: "/fr/reseau/luia-dans-le-monde/:slug()",
    meta: _91slug_93q315p7T_LF_45HAbsQVjgrFa6uAN7LFoadmieJ4GDbtR0Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/national-committees/[slug].vue")
  },
  {
    name: "national-committees-slug___en",
    path: "/en/network/the-uia-worldwide/:slug()",
    meta: _91slug_93q315p7T_LF_45HAbsQVjgrFa6uAN7LFoadmieJ4GDbtR0Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/national-committees/[slug].vue")
  },
  {
    name: "national-committees-slug___es",
    path: "/es/red/la-uia-en-el-mundo/:slug()",
    meta: _91slug_93q315p7T_LF_45HAbsQVjgrFa6uAN7LFoadmieJ4GDbtR0Meta || {},
    component: () => import("/srv/www/uia-frontend/pages/national-committees/[slug].vue")
  },
  {
    name: "auth-private-payment-result___fr",
    path: "/fr/mon-espace/resultat-paiement",
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment-result.vue")
  },
  {
    name: "auth-private-payment-result___en",
    path: "/en/my-account/payment-result",
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment-result.vue")
  },
  {
    name: "auth-private-payment-result___es",
    path: "/es/mi-cuenta/resultado-pago",
    component: () => import("/srv/www/uia-frontend/pages/auth/private/payment-result.vue")
  },
  {
    name: "user-commission-roles___fr",
    path: "/fr/user-commission-roles",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/index.vue")
  },
  {
    name: "user-commission-roles___en",
    path: "/en/user-commission-roles",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/index.vue")
  },
  {
    name: "user-commission-roles___es",
    path: "/es/user-commission-roles",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/index.vue")
  },
  {
    name: "juriste-internationals___fr",
    path: "/fr/ressources-digitales/juriste-internationals",
    component: () => import("/srv/www/uia-frontend/pages/juriste-internationals/index.vue")
  },
  {
    name: "juriste-internationals___en",
    path: "/en/digital-resources/juriste-internationals",
    component: () => import("/srv/www/uia-frontend/pages/juriste-internationals/index.vue")
  },
  {
    name: "juriste-internationals___es",
    path: "/es/recursos-digitales/juriste-internationals",
    component: () => import("/srv/www/uia-frontend/pages/juriste-internationals/index.vue")
  },
  {
    name: "pages-bars-and-organisations___fr",
    path: "/fr/reseau/barreaux-et-organisations",
    component: () => import("/srv/www/uia-frontend/pages/pages/bars-and-organisations.vue")
  },
  {
    name: "pages-bars-and-organisations___en",
    path: "/en/network/bars-and-organisations",
    component: () => import("/srv/www/uia-frontend/pages/pages/bars-and-organisations.vue")
  },
  {
    name: "pages-bars-and-organisations___es",
    path: "/es/red/bares-y-organizaciones",
    component: () => import("/srv/www/uia-frontend/pages/pages/bars-and-organisations.vue")
  },
  {
    name: "charters-and-resolutions___fr",
    path: "/fr/a-propos/chartes-et-resolutions-uia",
    component: () => import("/srv/www/uia-frontend/pages/charters-and-resolutions/index.vue")
  },
  {
    name: "charters-and-resolutions___en",
    path: "/en/about/charters-and-resolutions",
    component: () => import("/srv/www/uia-frontend/pages/charters-and-resolutions/index.vue")
  },
  {
    name: "charters-and-resolutions___es",
    path: "/es/sobre-la-uia/resoluciones-y-cartas-uia",
    component: () => import("/srv/www/uia-frontend/pages/charters-and-resolutions/index.vue")
  },
  {
    name: "documents-library-documentId___fr",
    path: "/fr/ressources-digitales/bibliotheque-documents/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/documents-library/[documentId].vue")
  },
  {
    name: "documents-library-documentId___en",
    path: "/en/digital-resources/documents-library/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/documents-library/[documentId].vue")
  },
  {
    name: "documents-library-documentId___es",
    path: "/es/recursos-digitales/biblioteca-documentos/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/documents-library/[documentId].vue")
  },
  {
    name: "events-slug-register-confirm___fr",
    path: "/fr/evenements/:slug()/confirmation-inscription",
    meta: register_45confirmyjpinmzZpsAYkWEwvzrM1Swcqg7oYQKcfcZDVu2inOsMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register-confirm.vue")
  },
  {
    name: "events-slug-register-confirm___en",
    path: "/en/events/:slug()/register-confirm",
    meta: register_45confirmyjpinmzZpsAYkWEwvzrM1Swcqg7oYQKcfcZDVu2inOsMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register-confirm.vue")
  },
  {
    name: "events-slug-register-confirm___es",
    path: "/es/eventos/:slug()/confirmar-registro",
    meta: register_45confirmyjpinmzZpsAYkWEwvzrM1Swcqg7oYQKcfcZDVu2inOsMeta || {},
    component: () => import("/srv/www/uia-frontend/pages/events/[slug]/register-confirm.vue")
  },
  {
    name: "auth-private-national-committees___fr",
    path: "/fr/mon-espace/comites-nationaux",
    meta: { ...(national_45committeesfv_45bYWeZWwHXU6ypuZXdz1fZ9uMeVv625D7jKI4p_cMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/national-committees.vue")
  },
  {
    name: "auth-private-national-committees___en",
    path: "/en/my-account/national-committees",
    meta: { ...(national_45committeesfv_45bYWeZWwHXU6ypuZXdz1fZ9uMeVv625D7jKI4p_cMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/national-committees.vue")
  },
  {
    name: "auth-private-national-committees___es",
    path: "/es/mi-cuenta/comites-nacionales",
    meta: { ...(national_45committeesfv_45bYWeZWwHXU6ypuZXdz1fZ9uMeVv625D7jKI4p_cMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/national-committees.vue")
  },
  {
    name: "user-commission-roles-documentId___fr",
    path: "/fr/user-commission-roles/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/[documentId].vue")
  },
  {
    name: "user-commission-roles-documentId___en",
    path: "/en/user-commission-roles/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/[documentId].vue")
  },
  {
    name: "user-commission-roles-documentId___es",
    path: "/es/user-commission-roles/:documentId()",
    component: () => import("/srv/www/uia-frontend/pages/user-commission-roles/[documentId].vue")
  },
  {
    name: "auth-private-president-communication___fr",
    path: "/fr/mon-espace/message-aux-membres",
    meta: { ...(president_45communicationnGU5ab_45_epPitHyqPUFkfx4_gdI8wxqWkrNLdTLu_s8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/president-communication.vue")
  },
  {
    name: "auth-private-president-communication___en",
    path: "/en/my-account/message-to-members",
    meta: { ...(president_45communicationnGU5ab_45_epPitHyqPUFkfx4_gdI8wxqWkrNLdTLu_s8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/president-communication.vue")
  },
  {
    name: "auth-private-president-communication___es",
    path: "/es/mi-cuenta/mensaje-a-miembros",
    meta: { ...(president_45communicationnGU5ab_45_epPitHyqPUFkfx4_gdI8wxqWkrNLdTLu_s8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/www/uia-frontend/pages/auth/private/president-communication.vue")
  },
  {
    name: "pages-uia-world-forum-of-mediation-centres___fr",
    path: "/fr/reseau/forum-mondial-de-mediation-UIA",
    component: () => import("/srv/www/uia-frontend/pages/pages/uia-world-forum-of-mediation-centres.vue")
  },
  {
    name: "pages-uia-world-forum-of-mediation-centres___en",
    path: "/en/network/uia-world-forum-of-mediation-centres",
    component: () => import("/srv/www/uia-frontend/pages/pages/uia-world-forum-of-mediation-centres.vue")
  },
  {
    name: "pages-uia-world-forum-of-mediation-centres___es",
    path: "/es/red/foro-mundial-de-los-centros-de-mediacion-de-la-uia",
    component: () => import("/srv/www/uia-frontend/pages/pages/uia-world-forum-of-mediation-centres.vue")
  },
  {
    name: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IA
  },
  {
    name: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IA
  },
  {
    name: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubGBPmV8dGBrcn9dI41Q0C9HIO3zGO1leuQ4f3vIR_2IA
  }
]